import {
    FaBrain, FaGamepad, FaArrowsRotate, FaClipboardList, FaFlask, FaHeadset, FaUserDoctor,
    FaPills,
    FaHandHoldingMedical,
} from "react-icons/fa6";


export const featuresCardData = [
    {
        icon: <FaBrain />,
        title: "Improved Patient Care",
        description:
            "Quicker turnaround times mean faster diagnosis and treatment planning for your patients.",
    },
    {
        icon: <FaGamepad />,
        title: "Enhanced Revenue Opportunities",
        description:
            "Retain the revenue currently lost to external reference labs by performing testing in-house.",
    },
    {
        icon: <FaArrowsRotate />,
        title: "Greater Control Over Testing",
        description:
            "Maintain the highest quality standards with full oversight of your lab's testing protocols.",
    },
];

export const collectionSteps = [
    {
        id: 1,
        number: "01",
        icon: <FaClipboardList />,
        title: "Planning & Setup",
        description:
            "We design and build labs around your practice needs, ensuring an efficient layout and the right equipment.",
    },
    {
        id: 2,
        number: "02",
        icon: <FaFlask />,
        title: "Ready-to-Use Labs",
        description:
            "We provide fully operational lab spaces with trained staff to manage toxicology testing efficiently.",
    },
    {
        id: 3,
        number: "03",
        icon: <FaHeadset />,
        title: "Continuous Support",
        description:
            "We help maintain compliance, improve lab efficiency, and provide ongoing support and upgrades as needed.",
    },
];

export const stepper = [
    {
        icon: <FaUserDoctor />,
        title: "Primary Care Physicians",
        description: "Get quick tests to enhance patient care.",
        align: "bottom",
    },
    {
        icon: <FaPills />,
        title: "Pain Clinics",
        description: "Check if patients follow medication plans.",
        align: "top",
    },
    {
        icon: <FaBrain />,
        title: "Behavioral Health Centers",
        description: "Use precise tests to tackle substance use issues.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaHandHoldingMedical />,
        title: "Addiction Recovery Facilities",
        description: "Conduct drug tests to assist treatment strategies.",
        align: "top",
    },
];